import { render, staticRenderFns } from "./AccountFacebook.vue?vue&type=template&id=7fdac844&scoped=true"
import script from "./AccountFacebook.vue?vue&type=script&lang=js"
export * from "./AccountFacebook.vue?vue&type=script&lang=js"
import style0 from "./AccountFacebook.vue?vue&type=style&index=0&id=7fdac844&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdac844",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdac844')) {
      api.createRecord('7fdac844', component.options)
    } else {
      api.reload('7fdac844', component.options)
    }
    module.hot.accept("./AccountFacebook.vue?vue&type=template&id=7fdac844&scoped=true", function () {
      api.rerender('7fdac844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page2/AccountFacebook.vue"
export default component.exports